import { Schema } from "effect";

/**
 * `Schema.Class` whose encoded struct also carries the identifier. v4 annotates only the class
 * declaration, so OpenAPI would name the encoded body `${identifier}Encoded`; v3 used the identifier
 * itself, and clients generated from the spec depend on those component names.
 */
export const OpenApiClass =
  // Self and Fields flow into the returned class type, as in `Schema.Class` itself.
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
  <Self>(identifier: string) =>
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
    <const Fields extends Schema.Struct.Fields>(fields: Fields) =>
      Schema.Class<Self>(identifier)(Schema.Struct(fields).annotate({ identifier }));
